module.exports = __webpack_public_path__ + "img/pressure_plate_settings.25fb0201.png";